import { NavGroupData } from "layouts/Sidenav/const";

export const findBreadcrumbsByPath = (menu: NavGroupData[], path: string) => {
  const basePath = path.split("/")[1];
  for (const item of menu) {
    // Kiểm tra nếu path trùng với item
    if (item.path?.includes(basePath)) {
      return [{ label: item.label, path: item.path }];
    }

    // Kiểm tra trong navSubList nếu tồn tại
    if (item.navSubList) {
      for (const subItem of item.navSubList) {
        if (subItem.path.includes(basePath)) {
          return [
            { label: item.label, path: item.path },
            { label: subItem.subLabel, path: subItem.path },
          ];
        }
      }
    }
  }
  return []; // Nếu không tìm thấy breadcrumbs
};
